<script setup lang="ts">

import {IconCloseCircle} from "@qingjs/icons";
import {useApiErrorsModal} from "@codeages-private/qingjs-vue-skeleton-base";
import {computed, ref} from "vue";

const props = withDefaults(defineProps<{
    /**
     * 同时最多可以显示多少个 Error
     * 默认最多可显示 100 个，多于的抛弃不显示，以免页面中不断抛出错误，最终导致页面卡死。
     */
    maxErrors?: number,
}>(), {
    maxErrors: 100,
});

const {
    visible,
    errors,
    currentError,
    currentErrorIndex,
    nextError,
    prevError} = useApiErrorsModal(ref(props.maxErrors));

const isNot404Error = computed(() => errors.value.filter((err) => err.status != 404).length > 0);
const showServiceQrcode = ref(false);

</script>

<template>
    <a-modal
        v-model:open="visible"
        :footer="null"
        :mask-style="{'background-color': 'rgba(0, 0, 0, 0.2)'}">
        <div class="flex" v-if="currentError">
            <div class="mr-4 flex items-center">
                <icon-close-circle class="w-16 h-16 text-error" />
            </div>
            <div class="w-full">
                <div class="text-xl text-gray-600 mb-2">{{ currentError.title }}</div>
                <div class="text-base text-gray-500 mb-2" v-if="currentError.message">{{ currentError.message }}</div>
                <div class="text-gray-400 text-xs mb-2" v-if="currentError.status > 0">
                    {{ currentError.status }} - {{ currentError.code }} - {{ currentError.path }}
                </div>
                <div class="text-gray-400 text-xs">
                    <span>ID: {{ currentError.traceId }}</span>
                </div>

                <div class="flex space-x-2 mt-2" v-if="errors.length > 1">
                    <div class="flex justify-center items-center w-5 h-5 border text-sm text-gray-400 hover:bg-gray-100 cursor-pointer select-none" @click="prevError">&lt;</div>
                    <div class="text-gray-500" v-if="currentErrorIndex !== null">{{ currentErrorIndex + 1 }} / {{ errors.length }}</div>
                    <div class="flex justify-center items-center w-5 h-5 border text-sm text-gray-400 hover:bg-gray-100 cursor-pointer select-none" @click="nextError">&gt;</div>
                </div>

                <div class="mt-2" v-if="isNot404Error && !showServiceQrcode">
                    <span @click="showServiceQrcode = true" class="cursor-pointer text-primary hover:underline">联系客服</span>
                </div>
            </div>
        </div>

        <div class="flex justify-center mt-6">
            <a-button @click="visible = false">关闭</a-button>
        </div>
    </a-modal>
</template>
